var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReinforcedConcrete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.161,
    height: 33.683,
    viewBox: "0 0 30.161 33.683",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#1899cc}.cls-2{fill:#272727}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14736",
    transform: "translate(0.5 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11944",
    transform: "translate(4.693 7.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11603",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4536",
    d: "M0 0H12.272V5.24H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11942",
    transform: "translate(0.184 7.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11605",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4537",
    d: "M0 0H4.509V5.24H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11945",
    transform: "translate(4.508 6.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11617",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25917",
    d: "M74.623 323.312H61.984v-5.606h12.639zm-12.272-.366h11.905v-4.874H62.35z",
    className: "cls-2",
    transform: "translate(-61.984 -317.706)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11943",
    transform: "translate(0 6.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11619",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25918",
    d: "M60.7 323.312h-4.872v-5.606H60.7zm-4.509-.366h4.143v-4.874h-4.14z",
    className: "cls-2",
    transform: "translate(-55.828 -317.706)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11938",
    transform: "translate(19.85 22.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11599",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4534",
    d: "M0 0H9.075V5.24H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11940",
    transform: "translate(19.85 12.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11599-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4534-2",
    d: "M0 0H9.075V5.601H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11939",
    transform: "translate(19.69 22.517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11613",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25915",
    d: "M79.442 330.466h-9.393v-5.606h9.393zm-9.076-.366h8.759v-4.874h-8.759z",
    className: "cls-2",
    transform: "translate(-70.049 -324.86)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11941",
    transform: "translate(19.69 12.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11613-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25915-2",
    d: "M79.442 330.644h-9.393v-5.784h9.393zm-9.076-.378h8.759v-5.029h-8.759z",
    className: "cls-2",
    transform: "translate(-70.049 -324.86)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10043",
    transform: "translate(17.879 0.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Trazado_23237",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25650",
    d: "M63.362 296.38h.015l.156-.007 4.314-1.3a.476.476 0 0 0 .379-.395.494.494 0 0 0-.166-.528l-1.4-1.4v-1.078l.269-.215.029.007a.816.816 0 0 0 .181.024.961.961 0 0 0 .7-.277l1.559-1.406a1 1 0 0 0 .048-1.412l-.08-.08a1 1 0 0 0-1.406-.042l-1.563 1.41a1.043 1.043 0 0 0-.274 1.06l-.331.269a.5.5 0 0 0-.212.438v.264l-.683-.656a.538.538 0 0 0-.532-.154.629.629 0 0 0-.378.366l-1.151 4.407a.525.525 0 0 0 .166.545.486.486 0 0 0 .36.16zm.1-.321h-.091a.191.191 0 0 1-.148-.062.217.217 0 0 1-.08-.23l1.147-4.4a.3.3 0 0 1 .169-.158.222.222 0 0 1 .206.073l1.234 1.184v-1.025a.191.191 0 0 1 .082-.172l.527-.429-.05-.113a.718.718 0 0 1 .156-.811l1.562-1.408a.683.683 0 0 1 .959.029l.08.08a.682.682 0 0 1-.035.954l-1.563 1.409a.615.615 0 0 1-.461.188h-.042a.383.383 0 0 1-.076-.014.6.6 0 0 0-.154-.024h-.056l-.486.389v1.365l1.512 1.509a.186.186 0 0 1 .061.2.178.178 0 0 1-.141.16z",
    className: "cls-1",
    transform: "translate(-62.815 -288.01)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11916",
    transform: "translate(0.184 12.217)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11595",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4532",
    d: "M0 0H10.412V5.243H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11917",
    transform: "translate(16.964 17.459)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11597",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4533",
    d: "M0 0H11.936V5.243H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11918",
    transform: "translate(10.6 22.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11599-3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4534-3",
    d: "M0 0H10.477V5.24H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11919",
    transform: "translate(10.6 12.216)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11601",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4535",
    d: "M0 0H10.477V5.243H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11920",
    transform: "translate(4.693 17.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11603-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4536-2",
    d: "M0 0H12.272V5.24H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11921",
    transform: "translate(0.184 17.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11605-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4537-2",
    d: "M0 0H4.509V5.24H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11922",
    transform: "translate(0.184 22.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11607",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4538",
    d: "M0 0H10.412V5.24H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11923",
    transform: "translate(0 12.034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11609",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25913",
    d: "M66.606 316.155H55.828v-5.609h10.778zm-10.412-.366H66.24v-4.876H56.194z",
    className: "cls-2",
    transform: "translate(-55.828 -310.546)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11924",
    transform: "translate(16.782 17.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11611",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25914",
    d: "M91.042 323.313H78.74V317.7h12.3zm-11.936-.366h11.57v-4.877h-11.57z",
    className: "cls-2",
    transform: "translate(-78.74 -317.704)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11925",
    transform: "translate(10.416 22.517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11613-3",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25915-3",
    d: "M80.893 330.467H70.049v-5.607h10.844zm-10.478-.367h10.112v-4.874H70.415z",
    className: "cls-2",
    transform: "translate(-70.049 -324.86)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11926",
    transform: "translate(10.416 12.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11615",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25916",
    d: "M80.893 316.154H70.049v-5.61h10.844zm-10.478-.366h10.112v-4.878H70.415z",
    className: "cls-2",
    transform: "translate(-70.049 -310.544)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11927",
    transform: "translate(4.508 17.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11617-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25917-2",
    d: "M74.623 323.312H61.984v-5.606h12.639zm-12.272-.366h11.905v-4.874H62.35z",
    className: "cls-2",
    transform: "translate(-61.984 -317.706)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11928",
    transform: "translate(0 17.278)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11619-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25918-2",
    d: "M60.7 323.312h-4.872v-5.606H60.7zm-4.509-.366h4.143v-4.874h-4.14z",
    className: "cls-2",
    transform: "translate(-55.828 -317.706)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11929",
    transform: "translate(16.964 27.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11621",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4539",
    d: "M0 0H11.936V5.243H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11930",
    transform: "translate(4.693 27.942)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11623",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4540",
    d: "M0 0H12.272V5.24H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11931",
    transform: "translate(0.184 27.942)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11625",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4541",
    d: "M0 0H4.509V5.24H0z",
    className: "cls-1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11932",
    transform: "translate(16.782 27.757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11627",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25919",
    d: "M91.042 337.623H78.74v-5.608h12.3zm-11.936-.366h11.57v-4.876h-11.57z",
    className: "cls-2",
    transform: "translate(-78.74 -332.015)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11933",
    transform: "translate(4.508 27.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11629",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25920",
    d: "M74.623 337.623H61.984v-5.606h12.639zm-12.272-.366h11.905v-4.873H62.35z",
    className: "cls-2",
    transform: "translate(-61.984 -332.017)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11934",
    transform: "translate(0 27.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11631",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25921",
    d: "M60.7 337.623h-4.872v-5.606H60.7zm-4.509-.366h4.143v-4.873h-4.14z",
    className: "cls-2",
    transform: "translate(-55.828 -332.017)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11935",
    transform: "translate(0 22.517)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_11633",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25922",
    d: "M66.606 330.467H55.828v-5.607h10.778zm-10.412-.367H66.24v-4.874H56.194z",
    className: "cls-2",
    transform: "translate(-55.828 -324.86)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25985",
    fill: "none",
    stroke: "#272727",
    d: "M-15662.059-9918.282v33.183h29.161v-33.183",
    transform: "translate(15662.059 9918.282)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReinforcedConcrete);
export default __webpack_public_path__ + "static/media/reinforced-concrete.81dc8a28266bad952ef5603759ac1246.svg";
export { ForwardRef as ReactComponent };